<template>
  <el-form
    ref="form"
    size="medium"
    label-position="right"
    label-width="150px"
    class="demo-form-inline leftpad"
  >
    <el-form-item label="是否接受再次检测">
      <el-select v-model="userAfterExam.acceptReexam">
        <el-option label="接受" value="0"></el-option>
        <el-option label="不接受" value="1"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="检测反馈">
      <el-input type="textarea" v-model="userAfterExam.checkFeedBack">
      </el-input>
    </el-form-item>
    <el-form-item label="基础病好转情况">
      <el-select v-model="userAfterExam.basicIllImprovement">
        <el-option label="明显好转" value="0"></el-option>
        <el-option label="不明显好转" value="1"></el-option>
        <el-option label="未改变" value="2"></el-option>
        <el-option label="轻微恶化" value="3"></el-option>
        <el-option label="恶化严重" value="4"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="饮食">
      <el-select v-model="userAfterExam.diet">
        <el-option label="不正常" value="0"></el-option>
        <el-option label="正常" value="1"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="精神">
      <el-select v-model="userAfterExam.spirit">
        <el-option label="明显好转" value="0"></el-option>
        <el-option label="未改变" value="1"></el-option>
        <el-option label="不好" value="2"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="工作和休息">
      <el-select v-model="userAfterExam.workAndRest">
        <el-option label="正常" value="0"></el-option>
        <el-option label="不正常" value="1"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="吃药情况">
      <el-select v-model="userAfterExam.medicine">
        <el-option label="正常吃药" value="0"></el-option>
        <el-option label="未按时吃药" value="1"></el-option>
        <el-option label="停药" value="2"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="运动">
      <el-select v-model="userAfterExam.sport">
        <el-option label="经常" value="0"></el-option>
        <el-option label="偶尔" value="1"></el-option>
        <el-option label="从不" value="2"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="保健药品">
      <el-select v-model="userAfterExam.healthProduct">
        <el-option label="经常" value="0"></el-option>
        <el-option label="偶尔" value="1"></el-option>
        <el-option label="从不" value="2"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="意见及建议">
      <el-input type="textarea" v-model="userAfterExam.compliance"></el-input>
    </el-form-item>
    <el-form-item label="其他">
      <el-input type="textarea" v-model="userAfterExam.other"></el-input>
    </el-form-item>

    <el-form-item>
      <el-button type="primary" @click="feedbackInfoUpdate" class="fullWidth" style="width:100%"
        >保存</el-button
      >
    </el-form-item>
  </el-form>
</template>

<script>
import { ExamStatesValue } from "../../utils/constants";
import { Util_updateExamState } from "../../utils/util";
import { updateExamState } from "../../api/userExamService";
import { getUserAfterExam } from "../../api/userService";
import { updateUserAfterExam } from "../../api/userService";

export default {
  props: {
    examUuid: String,
    teleNum: String,
  },
  data() {
    return {
    //   teleNum: "",
      //禁用所有检测信息，让其只读，不能修改
      disabled:true,
      prescription: "",
      userAfterExam: {
        acceptReexam: "",
        basicIllImprovement: "",
        checkFeedBack: "",
        compliance: "",
        diet: "",
        healthProduct: "",
        medicine: "",
        other: "",
        spirit: "",
        sport: "",
        userAfterExamTeleNum: "",
        workAndRest: "",
      },
    };
  },
  methods: {
      _getUserAfterExam() {
      getUserAfterExam(this.teleNum).then((res) => {
        if (res.success) {
          if (res.data[0]) {
            this.userAfterExam = res.data[0];
          }
        }
      });
    },
    feedbackInfoUpdate() {
      updateUserAfterExam(this.userAfterExam).then((res) => {
        if (res.success) {
          //更新检查状态后，重新获取检查信息
          this._updateExamState(
            ExamStatesValue.FINISHED,
            this._getUserAfterExam
          );
        } else {
          this.$message({
            message: res.description,
            type: "warning",
          });
        }
      });
    },
    //更新检查状态、并重新获取更新的信息
    _updateExamState(state, reloadFunc) {
      //如果已到达，则将其状态改为30:基础问询中
      Util_updateExamState(
        this.examUuid,
        state,
        updateExamState,
        reloadFunc,
        this.$message
      );
    },
  },
  created() {
    this.userAfterExam.userAfterExamTeleNum = this.teleNum;
    this._getUserAfterExam();
  }
};
</script>

<style scoped lang="less">

</style>
